import { Component, ElementRef, HostBinding, Input } from "@angular/core";
import { FocusableOption } from "@angular/cdk/a11y";
import { AvailabilityType } from 'src/app/dashboard/interfaces/availability-type.interface';

@Component({
  selector: "app-multi-select-dropdown-list-item",
  templateUrl: "./multi-select-dropdown-list-item.component.html",
  host: {
    tabindex: "-1",
    role: "list-item"
  },
  styles: [
    `
           :host {
             display: block;
           }
         `
  ]
})
export class MultiSelectDropdownListItemComponent implements FocusableOption {
  @HostBinding("class") class = "dropdown-list-item";

  @Input() option: string;
  @Input() type: AvailabilityType;

  constructor(private element: ElementRef) {}

  focus() {
    this.element.nativeElement.focus();
  }

  ngOnInit(): void {}
}
